function AddMicroSiteConfigCtrl($scope) { //eslint-disable-line
  if (!$scope.venue) throw new Error('venue is required');

  // const vm = this;
}

AddMicroSiteConfigCtrl.$inject = [
  '$scope'
];

export default AddMicroSiteConfigCtrl;



// WEBPACK FOOTER //
// ./src/directives/addMicroSiteConfig/controller.js